import { render, staticRenderFns } from "./MessagingPolicy.vue?vue&type=template&id=41d228ac&"
import script from "./MessagingPolicy.vue?vue&type=script&lang=js&"
export * from "./MessagingPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports